import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import './style/_base.scss';
import './style/element-variables.scss';
import App from './App.vue';
import router from './router';
import store from './store/index';
import * as filters from '@/filter/index.js';

import axiosHttpInterceptor from './interceptor';
import message from '@/utils/message.js';

Vue.use(VueAxios, axios);
axiosHttpInterceptor.init();

// 过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 重置 ElementUI 默认属性
ElementUI.Dialog.props.closeOnClickModal.default = true;
ElementUI.Dialog.props.closeOnPressEscape.default = false;
Vue.use(ElementUI);

Vue.config.productionTip = false;

// 消息提示
Object.keys(message).forEach(key => {
  Vue.prototype['$' + key] = message[key];
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
